import * as types from "../actions/types/openApi.types";

const initialState = {
    subaccounts: [],
    searchSubaccounts: {},
    subaccountsCreated: 0,
    subaccountTransactions: [],
    transactionsRecordsInStore: 0,
    filteredTransactions: [],
    subAccountsInStore: 0,
    createdState: "idle",
    subaccountsState: "loading",
    searchSubaccountState: "idle",
    transactionsState: "loading",
    filteredTransactionState: "idle",
};

export const openApiCustomerReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_SUBACCOUNTS_CREATED_INPROGRESS:
            return {
                ...state,
                createdState: "loading",
            };
        case types.GET_SUBACCOUNTS_CREATED_FAILURE:
            return {
                ...state,
                createdState: "failed",
            };
        case types.GET_SUBACCOUNTS_CREATED_SUCCESS:
            return {
                ...state,
                subaccountsCreated: action.data,
                createdState: "success",
            };
        case types.GET_SUBACCOUNTS_INPROGRESS:
            return {
                ...state,
                subaccountsState: "loading",
            };
        case types.GET_SUBACCOUNTS_FAILURE:
            return {
                ...state,
                subaccountsState: "failed",
            };
        case types.GET_SUBACCOUNTS_SUCCESS:
            return {
                ...state,
                subaccounts: action.data,
                subAccountsInStore: action.recordsInStore,
                subaccountsState: "success",
            };
        case types.GET_SEARCH_SUBACCOUNTS_INPROGRESS:
            return {
                ...state,
                searchSubaccountState: "loading",
            };
        case types.GET_SEARCH_SUBACCOUNTS_FAILURE:
            return {
                ...state,
                searchSubaccountState: "failed",
            };
        case types.GET_SEARCH_SUBACCOUNTS_SUCCESS:
            return {
                ...state,
                searchSubaccountState: "success",
                searchSubaccounts: action.data,
                subAccountsInStore: action.recordsInStore,
            };
        case types.GET_SUBACCOUNT_TRANSACTIONS_INPROGRESS:
            return {
                ...state,
                transactionsState: "loading",
            };
        case types.GET_SUBACCOUNT_TRANSACTIONS_FAILURE:
            return {
                ...state,
                transactionsState: "failed",
            };
        case types.GET_SUBACCOUNT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                subaccountTransactions: action.data,
                transactionsRecordsInStore: action.recordsInStore,
                transactionsState: "success",
            };
        case types.GET_FILTERED_SUBACCOUNT_TRANSACTIONS_INPROGRESS:
            return {
                ...state,
                filteredTransactionState: "loading",
            };
        case types.GET_FILTERED_SUBACCOUNT_TRANSACTIONS_FAILURE:
            return {
                ...state,
                filteredTransactionState: "failed",
            };
        case types.GET_FILTERED_SUBACCOUNT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                filteredTransactions: action.data,
                transactionsRecordsInStore: action.recordsInStore,
                filteredTransactionState: "success",
            };
        default:
            return state;
    }
};
